import { updateCurrentSlideThumbnail, updateShapeRotation } from '../../actions/CurrentSlideActions';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import React from 'react';
import { MenuInput, SecondaryMenuButton } from './SizeAndPositionButtons';
import locales from '../../locales/LocalesManager';
import storeManager from '../../store/StoreManager';
import {connect} from "react-redux";

const RotationViewContent = React.createClass({
    getInitialState(){
        const shapeModel = this.getContextTarget();

        return {
            rotation: shapeModel.rotation
        };
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
            var contextTarget = this.getContextTarget();

            this.setState({rotation: contextTarget.rotation});
        }
    },
    getContextTarget() {
        const shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.shapeModel.uuid)
                return shapes[i];
        }

        return this.props.shapeModel;
    },
    changeRotation(rotation) {
        const shapeModel = this.getContextTarget();

        if (!shapeModel)
            return;

        if (shapeModel.rotation !== rotation) {
            this.props.dispatch(updateShapeRotation(shapeModel.uuid, rotation));
            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();
            this.setState({rotation});
            this.props.dispatch(updateCurrentSlideThumbnail(true));
            this.forceUpdate();
        }
    },
    render() {
        const smallTextStyle = {
            fontSize: '12px',
            marginTop: '15px',
            marginBottom: '-5px'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        return (
            <div>
                <h3 style={smallTextStyle}>{locales.getCaption('Rotation', 'sizePosMenu')}</h3>

                <div style={buttonWrapperStyle}>
                    <SecondaryMenuButton clickHandler={this.changeRotation} type={0} caption={locales.getCaption('RotateTo', 'sizePosMenu') + ' 0°'}/>
                    <SecondaryMenuButton clickHandler={this.changeRotation} type={90} caption={locales.getCaption('RotateTo', 'sizePosMenu') + ' 90°'}/>
                    <SecondaryMenuButton clickHandler={this.changeRotation} type={180} caption={locales.getCaption('RotateTo', 'sizePosMenu') + ' 180°'}/>
                    <SecondaryMenuButton clickHandler={this.changeRotation} type={270} caption={locales.getCaption('RotateTo', 'sizePosMenu') + ' 270°'}/>
                </div>

                <div style={buttonWrapperStyle}>
                    <MenuInput id="resizeLastItem" isInt={true} labelText={locales.getCaption('SetRotationInDegrees', 'sizePosMenu')} value={this.state.rotation} onChangeHandler={this.changeRotation}/>
                </div>
            </div>
        )
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var refreshShapePosition = state.menu.refreshShapePosition;

    return {
        refreshShapePosition
    };
}

export const RotationView = connect(mapStateToProps)(RotationViewContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/RotationView.js
 **/